<template>
  <div class="info-panel-portrait-lt">
   
    <div class="info-panel-display-portrait">
     
      <div
        v-for="(num, index) of numbers"
        :key="index"
        class="info-panel-number"
      >
        <div class="number-container">
          <div class="index">{{ getIndex(index) }}</div>
         <div v-for="(val,e) in num.numbers" :key="e" class="number">{{ getNumber(val)}}</div>
        </div>

        

        <div  class="type">         
          <div class="date">{{ getDate(num)}}</div>
        </div>
     

     
        <div class="bet">
           <span>{{ getRaffleType(num)}}</span>  {{ num.bet | addCurrency(currency, true) }}
          <!-- <p class="label-reventado">(R)</p>
          {{ num.reventadoBet | addCurrency(currency, true) }} -->
        </div>
        <div class="options">
          <v-btn class="option-button" icon @click="onDeleteClick(index)">
            <v-icon class="option-icon" color="black">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>  
   
   <v-navigation-drawer
      v-model="drawer"     
      right     
      absolute
      temporary
      
      width="50%"
      color="error"       
      
    >
    <div class="controls-container">
      <button
        @click.self="onClearClick"
        color="error"       
        class="info-panel-button"
      >      
        <v-icon class="control-button-icon">mdi-trash-can-outline</v-icon>
         {{ getPhrase('clear_label_button') }}
      </button> 
    </div>
     
   </v-navigation-drawer>
   
   <div  @click="onShowControls" class="info-panel-controls">
     <v-icon class="info-panel-controls-icon">mdi-trash-can-outline</v-icon>
   </div>
   
  <!--   <div  @click="onClearClick" class="info-panel-controls">
       <v-btn
        @click="onClearClick"
        color="error"
        elevation="2"
        class="info-panel-button"
      >
        {{ lblClear }}
      </v-btn> 
    </div>  -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "InfoPanel",
  data() {
    return {
      lblGameLogo: "Game Logo",
      lblClear: "Limpiar",
      lblRooster: "GALLO CIEGO",
      lblImprimir: "IMPRIMIR",
      lblSorteos: "Sorteos",
      lblEditar: "Editar",
      lblEliminar: "Eliminar",
      lblTotalsTitle: "Resumen",
      lblTotalBet: "",
      offset: true,
      currentGameLogoSrc: "",
      drawer:false
    };
  },
  props: ["numbers", "currency", "totalBet", "raffleDays", "raffleTimes"],
  created() {
    this.lblSorteos = "Sorteos: ";
    this.lblDays = "Dias: ";
    this.lblTotalBet = "Total apostado en";
    this.currentGameLogoSrc = "../assets/nuevosTiemposLogo.png";
  },
  filters: {
    capitalized(val) {
      return val.charAt(0).toUpperCase() + val.slice(1);
    },
    addCurrency(val, currency, before) {
      if (val != "0" && val != "") {
        if (before) {
          return currency + " " + val;
        } else {
          return val + " " + currency;
        }
      } else {
        return val;
      }
    },
  },
 computed:{   
     ...mapGetters([
      'getPhrase',     
      // ...
    ])
  },
  methods: {
    getDate(num){
      return String(num.weekDay).toUpperCase()+' '+num.date;
    },
     getNumber(val){
      if(String(val).length === 1){
        return '0'+val;
      }else{
        return val;
      }
    },
    getBetClass(bet, reventadoBet) {
      if (String(bet).length > 5 || String(reventadoBet).length > 5) {
        return "bet big-bet";
      } else {
        return "bet";
      }
    },
    getRaffleType(raffle){
      if(raffle.blindRooster.length > 0 && raffle.revenge.length > 0){
        return  `(${raffle.blindRooster }) (${raffle.revenge })`
      }else if(raffle.blindRooster.length > 0 && raffle.revenge.length === 0){
        return  `(${raffle.blindRooster })`
      }else if(raffle.blindRooster.length === 0 && raffle.revenge.length > 0){
        return  `(${raffle.revenge })`
      }
    },
    onDeleteClick(index) {      
      this.$emit("delete-number", index);
    },
    getIndex(index) {
      var alphabet = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ];
      return alphabet[index];
    },
    onShowControls(){
      this.drawer = true;
    },
    onClearClick() {
      //console.log('onClearClick')
      document.activeElement.blur();
      this.drawer = false;
      this.$emit("clear-numbers");
      
    },
  },
};
</script>